import { TableStructure } from "../../components/TableStructure";

const List = [
  {
    fileStoreId: "ef9b0640-e489-47d4-b5ef-1a56f1926906",
    label: "3109-LP/2P-17/2018-I Thika Amendment",
  },
  {
    fileStoreId: "6ed2e97b-e818-43e8-b5ee-8b317853351f",
    label: "814-LP Thika Amendment Rules",
  },
  {
    fileStoreId: "4d1ab508-282c-4635-b6fd-269d406db9c5",
    label: "3815-LP/2P-17/2018-L Thika Amendment Rules Rate",
  },
  {
    fileStoreId: "bf30e1d8-3251-4c7a-9758-7144c1ec1be2",
    label: "WBLR & Thika Tenancy Act XI of 2019",
  },
  {
    fileStoreId: "5770eaae-d4ef-4d0f-8161-729650e4d0a0",
    label:
      "Form F Application for the Transfer of Interest of Thika Tenant as Thika Lessee.",
  },
  {
    fileStoreId: "a99a5f2e-6c71-43e1-a360-3bca532e47c0",
    label: "Form G Lease Agreement",
  },
  {
    fileStoreId: "d117c32e-eea1-40bf-b9e8-f812a6e2d4fc",
    label: "Form H Application for use of land or building for other purpose.",
  },
  {
    fileStoreId: "5cf12fbc-b638-4ff8-93a6-f8c89321627b",
    label:
      "Form I Application for transfer of vacant thika land to thika assignee.",
  },
  {
    fileStoreId: "90f42866-6093-41b3-a327-61c2ef851186",
    label:
      "Form J Application for betterment of living condition of thika lessee/Thika assignee.",
  },
];

export const WBThikaTenancyActAmendments = () => (
  <TableStructure
    title="WB Thika Tenancy Act, Amendments"
    heading={false}
    list={List}
    columnNo={1}
    leftMenuList={[
      {
        type: "link",
        to: "/WBThikaTenancyActAmendments",
        label: "WB Thika Tenancy Act, Amendments",
      },
    ]}
  />
);
